export const selectCompanyLoader = (state) => state.partnerOptions.loader
export const selectCompanyFilter = (state) => state.partnerOptions.selectedCompany
